/** @module Specification/NewSizeMapController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/xml",
], function(declare, lang, Action, ViewRef, Widget, xml) {

	return declare(Widget, {
		/**
		 * @override
		 * When creating new size map from source size range, automatically set SourceSizeRange
		 */
		_buildView: function() {
			const sourceUrl = this._getParentURLOfClientNode();

			if (xml.isValidURL(sourceUrl)) {
				this.addFixedValue("SourceSizeRange", sourceUrl);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Gets all the SizeRanges for Source Size Range and Target Size Range 
		 * when creating a new SizeMap from site-level Size Maps tab
		 */
		getFieldStore: function(field, value) {
			if (field.m_id == "TargetSizeRange") {
				return this.inherited(arguments);
			}

			return this.createHeadingNamesStore(this.getContext(), field, value, field.m_relationship, null, {
				action: lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "SizeRanges",
						m_url: "centric://APPAREL/Views"
					}),
				})
			});
		}
	});
});